import React from 'react'
import { usePromiseTracker } from "react-promise-tracker";

const LoadingAnimation = () => {
  const { promiseInProgress } = usePromiseTracker()
  return (
    <>
      {promiseInProgress && 
      <div className="wrapper">
        <div className="wrapper__container">
          <div className="wrapper-cell">
            <div className="image"></div>
            <div className="text">
              <div className="text-line"> </div>
              <div className="text-line"></div>
              <div className="text-line"></div>
              <div className="text-line"></div>
            </div>
          </div>
          <div className="wrapper-cell">
            <div className="image"></div>
            <div className="text">
              <div className="text-line"></div>
              <div className="text-line"></div>
              <div className="text-line"></div>
              <div className="text-line"></div>
            </div>
          </div>
          <div className="wrapper-cell">
            <div className="image"></div>
            <div className="text">
              <div className="text-line"> </div>
              <div className="text-line"></div>
              <div className="text-line"></div>
              <div className="text-line"></div>
            </div>
          </div>
          <div className="wrapper-cell">
            <div className="image"></div>
            <div className="text">
              <div className="text-line"></div>
              <div className="text-line"></div>
              <div className="text-line"></div>
              <div className="text-line">   </div>
            </div>
          </div>
        </div>
      </div>
      }
    </>
  )
}

export default LoadingAnimation
